import {createFileRoute, Navigate, Outlet} from '@tanstack/react-router'
import {useUser} from "@state/client/user.store.ts";

export const Route = createFileRoute('/_authenticated')({
  component: RouteComponent,
})

function RouteComponent() {
  const isLoggedIn = useUser(state => state.validate())


  if(!isLoggedIn) {
    return <Navigate to="/login" />
  }

  return <Outlet />
}
